import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders } from '@angular/core';
import { basicAuthInterceptor } from './basic-auth.interceptor';
import { camelCaseInterceptor } from './camel-case.interceptor';
import { errorInterceptor } from './error.interceptor';
import { loaderInterceptor } from './loader.interceptor';

/**
 * Lista ordenada de interceptores HTTP
 * El orden es importante:
 * 1. BasicAuth - Agrega credenciales
 * 2. CamelCase - Convierte nombres de propiedades
 * 3. Loader - Maneja estados de carga
 * 4. Error - Maneja errores (debe ser el último)
 */
export const HTTP_INTERCEPTORS_CHAIN: HttpInterceptorFn[] = [
  basicAuthInterceptor,
  camelCaseInterceptor,
  loaderInterceptor,
  errorInterceptor
];

/**
 * Provider para configurar todos los interceptores HTTP
 */
export const HTTP_INTERCEPTOR_PROVIDERS: EnvironmentProviders =
  provideHttpClient(
    withInterceptors(HTTP_INTERCEPTORS_CHAIN)
  );

/**
 * Interceptores disponibles para importación individual
 */
export const INTERCEPTORS = {
  basicAuth: basicAuthInterceptor,
  camelCase: camelCaseInterceptor,
  error: errorInterceptor,
  loader: loaderInterceptor
} as const;
